import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export function usePackagingDelete() {
    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete("/api/packagings/" + id);
            return response;
        },
    });

    return query;
}
